export enum StorageEnum {
  ESTABLISHMENT_PHOTOS = '/establishments/$id',
  OFFERS_FROM_ESTABLISHMENT_PHOTOS = '/establishments/$id/packs/$packId',
}
